<template>
  <modal
    :is-visible="isVisible"
    :title="title"
    @close="closeModal"
  >
    <form-wrap @submit="confirm">
      <p>{{ message }}</p>

      <form-actions>
        <button-input
          v-t="'c.confirmModal.form.action.confirm'"
          @click="confirm"
        />
        <a
          v-t="'c.confirmModal.form.action.cancel'"
          class="cancel"
          @click="closeModal()"
        />
      </form-actions>
    </form-wrap>
  </modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import Modal from '@/components/ui/Modal'

export default {
  name: 'ConfirmModal',
  mixins: [FormMixin],
  components: {
    Modal
  },
  computed: {
    title () {
      return this.$store.state.confirmModal.title
    },
    message () {
      return this.$store.state.confirmModal.message
    },
    isVisible () {
      return this.$store.state.confirmModal.isVisible
    }
  },
  methods: {
    ...mapActions({
      closeModal: 'closeConfirmModal',
      execConfirmCallback: 'execConfirmCallback',
    }),
    confirm () {
      this.execConfirmCallback()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app/ConfirmModal.vue